export enum ClientTypes {
    NON_VGCLIENT = 'non-vgclient',
    VGCLIENT = 'vgclient',
    UNKNOWN = 'UNKNOWN',
}
